var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "window", attrs: { id: "chat-container" } }, [
    _c(
      "div",
      {
        class: {
          "colored-nicks": _vm.$store.state.settings.coloredNicks,
          "time-seconds": _vm.$store.state.settings.showSeconds,
          "time-12h": _vm.$store.state.settings.use12hClock,
        },
        attrs: { id: "chat" },
      },
      [
        _c(
          "div",
          {
            staticClass: "chat-view",
            attrs: {
              "data-type": "search-results",
              "aria-label": "Search results",
              role: "tabpanel",
            },
          },
          [
            _c(
              "div",
              { staticClass: "header" },
              [
                _c("SidebarToggle"),
                _c("span", { staticClass: "title" }, [
                  _vm._v("Searching in "),
                  _c("span", { staticClass: "channel-name" }, [
                    _vm._v(_vm._s(_vm.channel.name)),
                  ]),
                  _vm._v(" for"),
                ]),
                _c("span", { staticClass: "topic" }, [
                  _vm._v(_vm._s(_vm.$route.query.q)),
                ]),
                _c("MessageSearchForm", {
                  attrs: { network: _vm.network, channel: _vm.channel },
                }),
                _c("button", {
                  staticClass: "close",
                  attrs: {
                    "aria-label": "Close search window",
                    title: "Close search window",
                  },
                  on: { click: _vm.closeSearch },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "chat-content" }, [
              _c(
                "div",
                { ref: "chat", staticClass: "chat", attrs: { tabindex: "-1" } },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.moreResultsAvailable,
                          expression: "moreResultsAvailable",
                        },
                      ],
                      staticClass: "show-more",
                    },
                    [
                      _c(
                        "button",
                        {
                          ref: "loadMoreButton",
                          staticClass: "btn",
                          attrs: {
                            disabled:
                              _vm.$store.state.messageSearchInProgress ||
                              !_vm.$store.state.isConnected,
                          },
                          on: { click: _vm.onShowMoreClick },
                        },
                        [
                          _vm.$store.state.messageSearchInProgress
                            ? _c("span", [_vm._v("Loading…")])
                            : _c("span", [_vm._v("Show older messages")]),
                        ]
                      ),
                    ]
                  ),
                  _vm.$store.state.messageSearchInProgress && !_vm.offset
                    ? _c("div", { staticClass: "search-status" }, [
                        _vm._v("\n\t\t\t\t\t\tSearching…\n\t\t\t\t\t"),
                      ])
                    : !_vm.messages.length && !_vm.offset
                    ? _c("div", { staticClass: "search-status" }, [
                        _vm._v("\n\t\t\t\t\t\tNo results found.\n\t\t\t\t\t"),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "messages",
                          attrs: {
                            role: "log",
                            "aria-live": "polite",
                            "aria-relevant": "additions",
                          },
                        },
                        [
                          _vm._l(_vm.messages, function (message, id) {
                            return [
                              _c(
                                "div",
                                {
                                  key: message.id,
                                  staticClass: "result",
                                  on: {
                                    ":click": function ($event) {
                                      return _vm.jump(message, id)
                                    },
                                  },
                                },
                                [
                                  _vm.shouldDisplayDateMarker(message, id)
                                    ? _c("DateMarker", {
                                        key: message.date,
                                        attrs: { message: message },
                                      })
                                    : _vm._e(),
                                  _c("Message", {
                                    key: message.id,
                                    attrs: {
                                      channel: _vm.channel,
                                      network: _vm.network,
                                      message: message,
                                      "data-id": message.id,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }